const { type } = require("jquery");

module.exports = {
    props: ['user', 'team'],

    data() {
        return {
            roles: [],
            permissions: {}, // Store permissions for each user
            inviteEmail: '',
            inviteRole: 'owner',
            adding: false,
            updatingTeamMember: null,
            deletingTeamMember: null,
            updateTeamMemberForm: new SparkForm({ role: '' }),
            deleteTeamMemberForm: new SparkForm({}),
        };
    },

    computed: {
        isTeamOwner() {
            if (!this.team || !this.user || !this.user.teams) return false;
        
            // Find the user's role in the specific team
            const userTeam = this.user.teams.find(team => team.id === this.team.id);
            return userTeam && userTeam.role === 'owner';
        },
        urlForUpdating() {
            return `/settings/${Spark.teamsPrefix}/${this.team.id}/members/${this.updatingTeamMember.id}`;
        },
        urlForDeleting() {
            return `/settings/${Spark.teamsPrefix}/${this.team.id}/members/${this.deletingTeamMember.id}`;
        },
    },

    mounted() {
        this.loadUserPermissions();
        this.getRoles();
    },

    methods: {
        getRoles() {
            if (Object.keys(Spark.roles).length > 0) {
                this.roles = Object.entries(Spark.roles).map(([key, value]) => {
                    return { value: key, text: value };
                });
            } else {
                axios.get(`/settings/${Spark.teamsPrefix}/roles`)
                    .then(response => {
                        this.roles = response.data;
                    });
            }
            axios.get(`/settings/${Spark.teamsPrefix}/roles`)
                .then(response => this.roles = response.data)
                .catch(error => console.error('Failed to fetch roles:', error));
        },

        loadUserPermissions() {
            axios.get(`/api/admin/teams/${this.team.id}/permissions`)
                .then(response => this.initializePermissions(response.data))
                .catch(error => console.error('Failed to load permissions:', error));
        },

        initializePermissions(permissionsData) {
            // Ensure Team users is converted to an array
            const teamUsers = Array.isArray(this.team.users) ? this.team.users : Object.values(this.team.users);
        
            teamUsers.forEach(user => {
                const userId = user.id;
                const userPermissions = permissionsData[userId] || {
                    manage_surveys: false,
                    manage_dashboard: false,
                };
        
                // Initialize permissions data for each user
                this.$set(this.permissions, userId, {
                    manage_surveys: userPermissions.manage_surveys,
                    manage_dashboard: userPermissions.manage_dashboard,
                });
            });
        },
        savePermissions(member) {
            const userId = member.id;
            const permissionData = {
                user_id: userId,
                team_id: this.team.id,
                manage_surveys: this.permissions[userId].manage_surveys,
                manage_dashboard: this.permissions[userId].manage_dashboard,
            };
        
            axios.post(`/api/admin/teams/${this.team.id}/permissions`, permissionData)
                .then(() => {
                    swal({
                        title: "Success!",
                        text: `Permissions updated for ${member.email}.`,
                        icon: "success",
                        button: "OK",
                        type: "success",
                    });
                })
                .catch(() => {
                    swal({
                        title: "Error!",
                        text: "Failed to update permissions. Please try again.",
                        icon: "error",
                        button: "Retry",
                        type: "error",
                    });
                });
        },

        formatPermission(permission) {
            return permission.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        },

        editTeamMember(member) {
            this.updatingTeamMember = member;
            this.updateTeamMemberForm.role = member.pivot.role;
            $('#modal-update-team-member').modal('show');
        },

        update() {
            Spark.put(this.urlForUpdating, this.updateTeamMemberForm)
                .then(() => {
                    Bus.$emit('updateTeam');
                    $('#modal-update-team-member').modal('hide');
                });
        },

        approveTeamMemberDelete(member) {
            this.deletingTeamMember = member;
            $('#modal-delete-member').modal('show');
        },

        deleteMember() {
            Spark.delete(this.urlForDeleting, this.deleteTeamMemberForm)
                .then(() => {
                    Bus.$emit('updateTeam');
                    $('#modal-delete-member').modal('hide');
                });
        },

        canEditTeamMember(member) {
            return this.user.id === this.team.owner_id && this.user.id !== member.id;
        },

        canDeleteTeamMember(member) {
            return this.user.id === this.team.owner_id && this.user.id !== member.id;
        },

        teamMemberRole(member) {
            if (this.roles.length === 0) {
                return '';
            }
            if (member.pivot.role === 'owner') {
                return 'Owner';
            }
            const role = this.roles.find(role => role.value === member.pivot.role);
            return role ? role.text : '';
        }
    },
};
